// MEGA MENU
function mmMegaMenuShowProducts(classElemsToHide, classElemToShow) {
  var imageContainers = document.querySelectorAll(classElemsToHide);
  imageContainers.forEach(function (imageContainer) {
    imageContainer.style.display = 'none';
  })
  document.querySelector(classElemToShow).style.display = 'grid';
}

// function getMegaMenuPosition(){
//   var menuElems = document.querySelectorAll('.mm-header-link');

//   menuElems.forEach(function(menuElem){
//     var viewportOffset = menuElem.getBoundingClientRect();
//     var headerBottom = viewportOffset.bottom;
//     console.log(headerBottom);

//     if (menuElem.nextElementSibling.classList.contains('mm-mega-menu-wrapper')){
//       // menuElem.nextElementSibling.style.top = "calc(" + headerBottom + "px - 4px)";
//     }
//   })
// }

function updateTextImageSections() {
  const textImageSections = document.querySelectorAll('.mm-section-text-image:has(.mm-it-global-container)');

  if(textImageSections.length === 0) return;

  textImageSections.forEach(section => {
    updateTextImageSection(section);
  });
}

function updateTextImageSection(section, fromCollapse = false) {
  const globalContainer = section.querySelector('.mm-it-global-container');    
  const mediaContainer = section.querySelector('.mm-it-media-container');
  const mediaContainerHeight = mediaContainer.getBoundingClientRect().height;
  const contentContainer = section.querySelector('.mm-section-width') || section.querySelector('.mm-section');
  const contentContainerHeight = contentContainer.getBoundingClientRect().height;
  
  if(mediaContainerHeight == 0 || window.innerWidth <= 768 || screen.width <= 768) {
    globalContainer.style.height = "auto";
  } else{
    if (contentContainerHeight > mediaContainerHeight) {
      const offset = fromCollapse ? 200 : 40;
      globalContainer.style.height = contentContainerHeight + offset + 'px';
    } else {
      globalContainer.style.height = mediaContainerHeight + 'px';
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  updateTextImageSections();
});

window.addEventListener('resize', updateTextImageSections);

var header = document.querySelector(".mm-header");
if (header.classList.contains('mm-header-index')) {
  window.addEventListener("scroll", function () {
    var scrollPosition = window.scrollY || document.documentElement.scrollTop;
    if (scrollPosition > 100) {
      header.classList.add("mm-bg-white");
    } else {
      // Vérifier si la recherche prédictive est ouverte avant de retirer la classe
      const searchWrapper = document.querySelector('.search__wrapper');
      if (!searchWrapper || !searchWrapper.classList.contains('is-open')) {
        header.classList.remove("mm-bg-white");
      }
    }
  });

  header.addEventListener("mouseenter", function () {
    header.classList.add("mm-bg-white");
  });

  header.addEventListener("mouseleave", function () {
    // Vérifier si la recherche prédictive est ouverte avant de retirer la classe
    const searchWrapper = document.querySelector('.search__wrapper');
    if (!searchWrapper || !searchWrapper.classList.contains('is-open')) {
      header.classList.remove("mm-bg-white");
    }
  });
}

// HEADER SEARCH
/**
 * Ouvre ou ferme la recherche prédictive
 * @param {Event} event - L'événement de clic
 * @returns {void}
 */
function openSearch(event) {
  if (event) event.preventDefault();

  const searchWrapper = document.querySelector('.search__wrapper');
  const body = document.querySelector('body');

  // Toggle les classes nécessaires
  searchWrapper.classList.toggle('is-open');

  // Toggle la classe search-is-open sur le body pour bloquer/débloquer le scroll
  body.classList.toggle('search-is-open');

  if (searchWrapper.classList.contains('is-open')) {
    // Ajoute la classe mm-bg-white au header si nécessaire
    const header = document.querySelector('.mm-header');
    if (header) header.classList.add('mm-bg-white');

    // Focus sur le champ de recherche pour une meilleure expérience utilisateur
    setTimeout(() => {
      const searchInput = searchWrapper.querySelector('input[type="search"]');
      if (searchInput) searchInput.focus();
    }, 100);

    // Empêcher l'overlay de faire défiler la page en haut
    document.querySelector('.search-overlay').addEventListener('click', function (e) {
      // Fermer la recherche si on clique sur l'overlay
      if (e.target === this) {
        openSearch();
      }
    });
  } else {
    // Si on est sur la page d'accueil et qu'on ferme la recherche, on peut retirer
    // la classe mm-bg-white du header selon la position de défilement
    const header = document.querySelector('.mm-header');
    if (header && header.classList.contains('mm-header-index')) {
      const scrollPosition = window.scrollY || document.documentElement.scrollTop;
      if (scrollPosition <= 100) {
        header.classList.remove('mm-bg-white');
      }
    }
  }
}

// MOBILE MENU
function mmMobileMenu() {
  const header = document.querySelector("header");
  const icon = document.querySelector(".mm-header-burger");
  const mobileMenu = document.querySelector(".mm-mobile-menu-wrapper");
  document.querySelector("html").classList.toggle("stop-scrolling");
  document.querySelector("body").classList.toggle("stop-scrolling");

  header.classList.toggle("mm-open");
  icon.classList.toggle("mm-open");
  mobileMenu.classList.toggle("mm-menu-open");
  console.log('height :', document.getElementById('get_header_vertical_position').getBoundingClientRect().top);
  mobileMenu.style.top = document.getElementById('get_header_vertical_position').getBoundingClientRect().top + "px";
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);
function animatedDropdowns() {
  const faqColl = document.querySelectorAll('.mm-faq-collapsible');
  let q;

  for (q = 0; q < faqColl.length; q++) {
    faqColl[q].addEventListener('click', function () {
      this.classList.toggle('active');

      const content = this.nextElementSibling;

      if (content.style.maxHeight) {
        content.style.maxHeight = null;

        setTimeout(() => {
          if(this.closest('.mm-it-global-container')) updateTextImageSection(this.closest('.mm-section-text-image'), true);
        }, 100);
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';

        setTimeout(() => {
          if(this.closest('.mm-it-global-container')) updateTextImageSection(this.closest('.mm-section-text-image'), true);
        }, 100);
      }
    });
  }
}

window.addEventListener("DOMContentLoaded", (event) => {
  animatedDropdowns();
});

/* mobile drawer height */
const documentHeight = () => {
  const doc = document.documentElement
  doc.style.setProperty('--doc-height', `${window.innerHeight}px`)
}
window.addEventListener('resize', documentHeight)
documentHeight()

/* Popup recommanded duration */
function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);
